var _defs, _line, _line2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFDeskLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa06d2f5-d93d-4a82-902c-bc5302aa441e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361.33 133.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b6ae6e1d-ed8b-4317-8d7f-b4d67622b16a,.f7eb77c1-641e-4301-9d11-35880e0f8c66{fill:none;stroke:#6F6F6F;stroke-width:0.5px;}.b6ae6e1d-ed8b-4317-8d7f-b4d67622b16a{stroke-miterlimit:10;}.b485607b-c7ce-4a76-afd5-f2b48f521b06{fill:#6F6F6F;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b6ae6e1d-ed8b-4317-8d7f-b4d67622b16a",
    x1: 361.33,
    y1: 0.25,
    x2: 4.17,
    y2: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b6ae6e1d-ed8b-4317-8d7f-b4d67622b16a",
    x1: 4.17,
    y1: 124.48,
    x2: 4.17,
    y2: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a4a0b7cf-383f-4d34-a575-5e5636be75f5",
    "data-name": "Ellipse 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b485607b-c7ce-4a76-afd5-f2b48f521b06",
    cx: 4.5,
    cy: 129.12,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f7eb77c1-641e-4301-9d11-35880e0f8c66",
    cx: 4.5,
    cy: 129.12,
    r: 4.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFDeskLeft);
export default __webpack_public_path__ + "static/media/F-Desk-Left.b8c0152b82e40a89632979afad369c3b.svg";
export { ForwardRef as ReactComponent };